import { ADDITIONAL_TEXT_PREFIX_ID } from '@frontend/constants/templates-field-prefixes';
import parseText from '@/common/preview/parse-text';
import { FIELD_TYPE_TEXT } from '@frontend/constants/type-fields-of-template';
import {
  getLockValue,
  getSettingsDataInstance,
  getShadowFabricInstance,
  unFocusObjects,
  updateBoundingBoxInfo
} from '@frontend/utils';
import { scaleControlsCornerSize } from '@frontend/constants/fabric-constants';
import { formDataToObject } from '@frontend/lib/utils/form-data-to-object';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import {getGroupNameByAddFieldId} from "@/common/preview/draw-smart-object";

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data']);

export async function drawAdditionalText({
  canvas,
  id,
  previewBoundingBoxData
}) {
  unFocusObjects();

  canvas.getObjects().forEach(function (o) {
    if (o.id.startsWith(ADDITIONAL_TEXT_PREFIX_ID)) {
      canvas.remove(o);
    }
  });

  const { canvas_data } = getScopePage();

  const settingsTemplate = getSettingsDataInstance(canvas_data[id]._data?.settings_template);

  /* used to save bounding box info */
  const formData = new FormData();
  formData.append('type', ADDITIONAL_TEXT_PREFIX_ID);
  
  let index = 0;
  for (let field of canvas_data[id].additionalTexts) {
    const offset_x = canvas_data[id]._data[field + '_offset_x'] || '0';
    const offset_y = canvas_data[id]._data[field + '_offset_y'] || '0';
    const angle = canvas_data[id]._data[field + '_angle'] || '0';
    const color = canvas_data[id]._data[field + '_color'];
    const font = canvas_data[id]._data[field + '_font'] ?? 'Proxima-Nova-Semibold';
    const width = parseInt(canvas_data[id]._data[field + '_width']) || 300;
    const fontSize = parseInt(canvas_data[id]._data[field + '_fontsize']) || 100;
    const textAlign = canvas_data[id]._data[field + '_alignment'] || 'left';
    const charSpacing = canvas_data[id]._data[field + '_tracking'];
    const maxChars = Number(canvas_data[id]._data[`${field}_max_chars`] || 10000);

    const x = 0;
    const y = 0;
    const text_val = canvas_data[id]._data[field];
    const objectId = ADDITIONAL_TEXT_PREFIX_ID + index;
    index++;
    let fieldsOrderReassignedByUser = canvas_data[id]._data.users_fields_order;
    fieldsOrderReassignedByUser = fieldsOrderReassignedByUser ? JSON.parse(canvas_data[id]._data.users_fields_order) : false;
    const order = fieldsOrderReassignedByUser ? fieldsOrderReassignedByUser.indexOf(objectId) + 1 : 0;
    const visible = canvas_data[id]._data[`${field}_visible`] ?? true;
    const isCurved = canvas_data[id]._data[`${field}_is_curved`] || false;
    const curvedDiameter = Number(canvas_data[id]._data[`${field}_diameter`]) || 1000;
    const curvedKerning = 1.5;
    const { text, styles } = parseText(text_val, color);

    if (text !== '') {
      const textBox = new fabric.Textbox(text, {
        id: objectId,
        element_id: field,
        top: y + parseFloat(offset_y),
        left: x + parseFloat(offset_x),
        width: width,
        fontFamily: font,
        fontSize: fontSize,
        fill: color,
        selectable: true,
        evented: true,
        textAlign,
        charSpacing,
        fontSelector: true,
        colorSelector: true,
        fontThemeSelector: false,
        fontColor: color,
        order,
        name: settingsTemplate.getNameById(objectId, canvas_data[id]._data[field + '_name'] || '') || 'Additional Text ' + (index + 1),
        link: settingsTemplate.getLinkById(objectId, ''),
        fieldType: FIELD_TYPE_TEXT,
        styles,
        shadow: getShadowFabricInstance(id, field),
        locked: getLockValue(id, field),
        angle: angle ? parseFloat(angle) : 0,
        visible,
        groupName: getGroupNameByAddFieldId(
          objectId,
          canvas_data[id]
        ),
        isCurved,
        curvedDiameter,
        curvedKerning,
        maxChars,
      });
      
      textBox.setControlsVisibility({
        tr: true,
        br: true,
        bl: true,
        ml: false,
        mt: false,
        mr: false,
        mb: false,
        mtr: true,
      });
      
      scaleControlsCornerSize(textBox);
      canvas.add(textBox);

      /* update bounding box info */
      let bound = textBox.getBoundingRect();

      formData.append('element_ids[]', field);
      formData.append(field + '_width', textBox.width);
      formData.append(field + '_height', textBox.height);
      formData.append(field + '_b_width', bound.width);
      formData.append(field + '_b_height', bound.height);
      formData.append(field + '_offset_x', offset_x);
      formData.append(field + '_offset_y', offset_y);

    }
  }

  /* UPDATE BOUNDING BOX INFO */
  if (previewBoundingBoxData) {
    previewBoundingBoxData.data.push(formDataToObject(formData));
  } else {
    updateBoundingBoxInfo(formData, id);
  }
}
